import { connect } from "react-redux";
import { actionCreators, getScriptEditorPanelDraft, getScriptEditorPanelHasChanges, getScriptEditorPanelInProgress, getScriptEditorPanelShow, getScriptEditorPanelTargetOffset, getScriptEditorPanelTargetSelector } from "../redux";
import ScriptEditorPanel from "./scriptEditorPanel";
const mapStateToProps = (state) => ({
    draft: getScriptEditorPanelDraft(state),
    hasChanges: getScriptEditorPanelHasChanges(state),
    show: getScriptEditorPanelShow(state),
    targetSelector: getScriptEditorPanelTargetSelector(state),
    targetOffset: getScriptEditorPanelTargetOffset(state),
    inProgress: getScriptEditorPanelInProgress(state)
});
const mapDispatchToProps = (dispatch) => ({
    onClose: () => dispatch(actionCreators.setShowScriptEditorPanel(false)),
    onSave: (data) => dispatch(actionCreators.saveScript(data)),
    onSetDraft: (draft) => dispatch(actionCreators.setScriptDraft(draft))
});
export default connect(mapStateToProps, mapDispatchToProps)(ScriptEditorPanel);
